
import { doc, setDoc } from "firebase/firestore";
import { db } from "../lib/firebase";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import { Typography, Button, IconButton, Box, Container } from '@mui/material';
import backgroundImage from '../assets/bg.jpg';
import './LandingPage.css';
import TemporaryDrawer from "../components/drawer";

function Landing() {
  const navigate = useNavigate();

  // Fade in effects
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);


  // Generate unique string
  function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  // Generate room with unique link
  const handleCreateRoom = async () => {
    const UUID = generateUUID();
    await setDoc(doc(db, "rooms", UUID), {
      messages: []
    })
    navigate('/chat/'+UUID);
  }

    return (
      <Container
        sx={{
          minWidth: '100vw',
          overflow: 'hidden',
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'bottom center',
          zIndex: -1
        }}
      >
        <Box sx={{
          w:'100vw',
          minHeight:'100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',

        }}>
          
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-evenly',
            height: '20vh'

          }}
        >
          <Typography
            variant="h5"
            className="header"
            sx={{
              mb: 4,
              maxWidth: 'sm',
              color: 'white',
              opacity: visible ? 1 : 0,
              transition: 'opacity 1s 0.3s',
              textAlign: 'center'
              // fontSize: '3rem'
            }}
          >
            reach out to us <br />anything, anywhere, anytime
          </Typography>
          <Button
            variant="outlined"
            size="large"
            className="header"
            sx={{
              opacity: visible ? 1 : 0,
              transform: `translateY(${visible ? 0 : '1rem'})`,
              transition: 'opacity 1s 0.6s, transform 1s 0.5s',
              borderColor: 'white',
              textTransform: 'none',
              borderRadius: '20px',
              color: 'white',
              fontWeight: 'bold',
              padding: '10px 20px',
              '&:hover': {
                transition: '0.5s',
                color: 'white', 
                borderColor: 'white',
                transform: 'scale(1.05)',
                backgroundColor: 'transparent',
              },
            }}
            onClick={handleCreateRoom}
          >
            chat to us now
          </Button>
        </Box>
        </Box>
        {/* <IconButton
          sx={{
            position: 'absolute',
            top: 16,
            right: 16,
            color: 'white',
          }}
          aria-label="menu"
        >
          <MenuIcon />
        </IconButton> */}
        <TemporaryDrawer></TemporaryDrawer>
    </Container>
  );
};


export default Landing;
